var map;
var InfoObj = [];

var icons = {
  par2:{
    icon: 'https://cdn.shopify.com/s/files/1/0495/7532/9941/files/PAR2-pointer.png?v=1677793895'
  }
};

var markersOnMap = [
  {
    storecode: 'P01',
    placeName: 'PAR2 Santa Clara',
    storeAddress: 'CC Santa Clara Villanueva Local 103 y 104',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '40817269',
    whatsapp: '31516547',
    page: 'https://g.page/r/CUdd_R1zVfvKEBM',
    review: 'https://g.page/r/CUdd_R1zVfvKEBM/review',
    zona: 1,
    LatLng: [{
      lat: 14.5307798,
      lng: -90.5980798
    }],
    type: 'par2'
  },
  {
    storecode: 'P03',
    placeName: 'PAR2 El Gran Carchá',
    storeAddress: '7a C. y Av. San Pedro Carchá, Zona 2, Bo. San Sebastian, San Pedro Carchá',
    schedule: 'Lunes a Domingo: 10:00am a 9:00pm',
    phone: '49973355',
    whatsapp: '31516547',
    page: 'https://g.page/r/CVCcmEYxXMI-EBM',
    review: 'https://g.page/r/CVCcmEYxXMI-EBM/review',
    zona: 1,
    LatLng: [{
      lat: 15.4767656,
      lng: -90.3106077
    }],
    type: 'par2'
  },
  {
    storecode: 'P04',
    placeName: 'PAR2 El Frutal',
    storeAddress: 'CC El Frutal 1er. Nivel Local 26, 27 y 28, Blvd. El Frutal 14-00 Zona 5, Villa Nueva',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '66404801',
    whatsapp: '31516547',
    page: 'https://g.page/r/CRYF1Uxl1zCaEBM/',
    review: 'https://g.page/r/CRYF1Uxl1zCaEBM/review',
    zona: 1,
    LatLng: [{
      lat: 14.5214241,
      lng: -90.5647267
    }],
    type: 'par2'
  },
  {
    storecode: 'P05',
    placeName: 'PAR2 Santalú',
    storeAddress: 'Km. 87.9 Ctra. al Pacifico, frente a finca Las Ilusiones Zona 0, CC Santalú, Local 111',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br>Viernes y Sábado: 10:00am a 9:00pm',
    phone: '',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.3306995,
      lng: -91.0156699
    }],
    type: 'par2'
  },
  {
    storecode: 'P06',
    placeName: 'PAR2 Pradera Zacapa',
    storeAddress: '17 Av. y 1a. C. Zona 3, Frente a lote Col. Esmeralda, CC Pradera, 1er. Nivel, Local 3, Zacapa',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '77966663',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.9770397,
      lng: -89.5284207
    }],
    type: 'par2'
  },
  {
    storecode: 'P07',
    placeName: 'PAR2 Pradera Visitares',
    storeAddress: 'Pradera Visitares Local 217, Nivel 2, Diagonal 19 36-01',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br>Viernes y Sábado: 10:00am a 9:00pm',
    phone: '22210487',
    whatsapp: '31516547',
    page: 'https://g.page/r/CRoV4tr41CQaEBM',
    review: 'https://g.page/r/CRoV4tr41CQaEBM/review',
    zona: 1,
    LatLng: [{
      lat: 14.5832286,
      lng: -90.5440668
    }],
    type: 'par2'
  },
  {
    storecode: 'P08',
    placeName: 'PAR2 Naranjo',
    storeAddress: 'CC Naranjo Mall, Local 236 y 237, Zona 4 de Mixco',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '22127804',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.651138,
      lng: -90.5428022
    }],
    type: 'par2'
  },
  {
    storecode: 'P09',
    placeName: 'PAR2 Pradera Puerto Barrios',
    storeAddress: 'CC Pradera Puerto Barrios, Km 292.5 Ruta al Atlántico, Local 83-86, Puertos Barrios, Izabal',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br>Viernes y Sábado: 10:00am a 9:00pm',
    phone: '79429923',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 15.6981995,
      lng: -88.5869412
    }],
    type: 'par2'
  },
  {
    storecode: 'P10',
    placeName: 'PAR2 Galerías Miraflores',
    storeAddress: 'CC Galerías Miraflores Planta Baja, Local PB-116',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br>Viernes y Sábado: 10:00am a 9:00pm',
    phone: '22356034',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.6205337,
      lng: -90.553457
    }],
    type: 'par2'
  },
  {
    storecode: 'P11',
    placeName: 'PAR2 Centro',
    storeAddress: 'Zona 1, 6a Av. #15-51',
    schedule: 'Lunes a Domingo: 9:00am a 7:00pm',
    phone: '22514669',
    whatsapp: '31516547',
    page: 'https://g.page/r/CVfTW8Chp8OGEBM',
    review: 'https://g.page/r/CVfTW8Chp8OGEBM/review',
    zona: 1,
    LatLng: [{
      lat: 14.633202215941782,
      lng: -90.51520723158154
    }],
    type: 'par2'
  },
  {
    storecode: 'P12',
    placeName: 'PAR2 Interplaza Escuintla',
    storeAddress: 'Km 60, Autopista Palín, CC Interplaza Escuintla, Local 146 y 147, 1er. Nivel',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br>Viernes y Sábado: 10:00am a 9:00pm',
    phone: '30112623',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.2943944,
      lng: -90.7976865
    }],
    type: 'par2'
  },
  {
    storecode: 'P13',
    placeName: 'PAR2 CC Centra Norte',
    storeAddress: 'CA-9 Norte, Ruta al Atlántico Zona 17, 40-26 Centro Comercial Centra Norte, Primer Nivel Locales E29A, E30, E31 Y E3',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br>Viernes y Sábado: 10:00am a 9:00pm',
    phone: '49921953',
    whatsapp: '49921953',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.646269,
      lng: -90.4517392
    }],
    type: 'par2'
  },
  {
    storecode: 'P16',
    placeName: 'PAR2 Mazatenango',
    storeAddress: '6a Av. 9-41, Zona 1, Mazatenango',
    schedule: 'Lunes a Domingo: 8:00am a 7:00pm',
    phone: '78729031',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.5320635,
      lng: -91.5023759
    }],
    type: 'par2'
  },
  {
    storecode: 'P27',
    placeName: 'PAR2 El Encuentro Jalapa',
    storeAddress: 'El Encuentro Jalapa',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '50230973243',
    whatsapp: '50230973243',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.6284184,
      lng: -89.9799892
    }],
    type: 'par2'
  },
  {
    storecode: 'P28',
    placeName: 'PAR2 Pradera Escuintla',
    storeAddress: 'CC Pradera Escuintla, Local 43 y 44',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '31500903',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.2893869,
      lng: -90.7855275
    }],
    type: 'par2'
  },
  {
    storecode: 'P29',
    placeName: 'PAR2 Metrocentro Villanueva',
    storeAddress: 'CC Metrocentro Villanueva, Local 205-208',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '66317987',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.5141779,
      lng: -90.5765983
    }],
    type: 'par2'
  },
   {
    storecode: 'P40',
    placeName: 'PAR2 Portales Mall',
    storeAddress: 'Carretera al Atlantico 3-20 ciudad de Guatemala L-325 C.C. Portales, locales Km 4.5',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '30461559',
    whatsapp: '30461559',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.647891,
      lng: -90.482414
    }],
    type: 'par2'
  },
  {
    storecode: 'P43',
    placeName: 'PAR2 Chimaltenango',
    storeAddress: '7a C. 2-02, Zona 2, CC Pradera Chimaltenango, Local 43-44',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '78399766',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.6607238,
      lng: -90.8096858
    }],
    type: 'par2'
  },
  {
    storecode: 'P48',
    placeName: 'PAR2 Centro II',
    storeAddress: '6a. Av. 11-46, Zona 1',
    schedule: 'Lunes a Domingo: 9:00am a 7:00pm',
    phone: '22510547',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.63769,
      lng: -90.5145275
    }],
    type: 'par2'
  },
  {
    storecode: 'P68',
    placeName: 'PAR2 Trinidad',
    storeAddress: 'CC La Trinidad 1a. C y 5a. Av, Zona 5, Retalhuleo',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '77716865',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.532261,
      lng: -91.681041
    }],
    type: 'par2'
  },
  {
    storecode: 'P70',
    placeName: 'PAR2 Monserrat Mixco',
    storeAddress: 'CC Montserrat, Local 43-44, Zona 4 de Mixco',
    schedule: 'Lunes a Domingo: 9:00am a 7:00pm',
    phone: '24380253',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.6423612,
      lng: -90.5684737
    }],
    type: 'par2'
  },
  {
    storecode: 'P73',
    placeName: 'PAR2 Plaza Florida Mixco',
    storeAddress: 'CC Plaza Florida, Local 25 y 26, Zona 7 de Mixco',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '24331954',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.6493051,
      lng: -90.5839608
    }],
    type: 'par2'
  },
  {
    storecode: 'P90',
    placeName: 'PAR2 Pradera Xela Quezaltenango',
    storeAddress: 'CC La Pradera Xela Quetzaltenango, Local 47 y 48',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '77670262',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.8502012,
      lng: -91.535228
    }],
    type: 'par2'
  },
  {
    storecode: 'P24',
    placeName: 'PAR2 Centro Comercial Los Totonicapán',
    storeAddress: 'Kilómetro 200, Ruta nacional 1, Centro comercial Los Altos Local 109 Totonicapán',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '77670262',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.910107011098207, 
      lng:-91.37236570186087 
    }],
    type: 'par2'
  },
{
    storecode: 'P23',
    placeName: 'PAR2 Plaza Teca',
    storeAddress: 'Plaza Teca Coatepeque',
    schedule: 'Lunes a Domingo: 09:00am a 8:00pm',
    phone: '77670262',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.912682485862817, 
      lng:-91.8862758871223
    }],
    type: 'par2'
  }
];  

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("actived");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

function addMarkerInfo(){
  for(var i=0; i < markersOnMap.length; i++){
    var contentString = '<div class="place-name">' + markersOnMap[i].placeName + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
    if(markersOnMap[i].phone !== "")
    	contentString += '<div class="place-link"><a class="place-link" href="tel:+502'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="PAR2 Guatemala" style="width: 4%"> (502)'+ markersOnMap[i].phone + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=502'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="PAR2 Guatemala" style="width: 4%"> (502)' + markersOnMap[i].whatsapp + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="PAR2 Guatemala" style="width: 4%"> Navegar en Waze</a></div>';
    if(markersOnMap[i].page !== "")
    	contentString += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
    if(markersOnMap[i].review !== "")
    contentString += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div>';

    const marker = new google.maps.Marker({
      position: markersOnMap[i].LatLng[0],
      icon: icons[markersOnMap[i].type].icon,
      map: map
    });

    const infowindow = new google.maps.InfoWindow({
      content: contentString
    });


    marker.addListener('click', function(){
      closeOtherInfo();
      infowindow.open(marker.get('map'),marker);
      InfoObj[0] = infowindow;
    });
    
    switch (markersOnMap[i].zona) {
      case 1: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+502'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="PAR2 Guatemala" style="width: 4%"> (502)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=502'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="PAR2 Guatemala" style="width: 4%">(502)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="PAR2 Guatemala" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
      case 2: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+502'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%"> (502)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=502'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%">(502)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="PAR2 Guatemala" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info2").innerHTML += contentDiv;
        		break;
      
      case 3: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+502'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%"> (502)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=502'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%">(502)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="PAR2 Guatemala" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info3").innerHTML += contentDiv;
        		break;
      
      case 4: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+502'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%"> (502)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=502'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%">(502)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="PAR2 Guatemala" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info4").innerHTML += contentDiv;
        		break;
      
      default:
      			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+502'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%"> (502)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=502'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%">(502)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="PAR2 Guatemala" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
    }
  }
}

function closeOtherInfo(){
  if(InfoObj.length > 0){
    InfoObj[0].set("marker", null);
    InfoObj[0].close();
    InfoObj[0].length = 0;
  }
}

function SetCenterMap(posLat, posLon){
  var centerStore = {lat: posLat, lng: posLon};
  map.setCenter(centerStore);
}

function positionOk(pos){
  var latitudeMap = pos.coords.latitude;
  var longitudMap = pos.coords.longitude;
  var centerStore = {lat: latitudeMap, lng: longitudMap};
  map.setCenter(centerStore);
}

function positionKO(){
  const centerStore = {lat: 14.2893869, lng: -90.7855275};
  map.setCenter(centerStore);
}

function initMap(){
  map = new google.maps.Map(document.getElementById('map'),{
    zoom: 16,
    center: {lat: 14.2893869, lng: -90.7855275},
    mapId: '7b2b8c05c9abdb62'
  });

  if(navigator.geolocation){
    navigator.geolocation.getCurrentPosition(positionOk, positionKO);            
  }

  addMarkerInfo();
};

function openPage(pageName,elmnt) {
  var i, tabcontent;
  
  tabcontent = document.getElementsByClassName("tabcontent2");
  
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  };
    
  document.getElementById(pageName).style.display = "block";
  elmnt.style.borderBottom = "6px solid #FF6B00";
}